<!-- Botón con RouterLink (navegación interna) -->
<a *ngIf="(route !== undefined || routerLink) && !href" [routerLink]="computedRouterLink" [class]="buttonClasses"
    [attr.disabled]="disabled ? true : null" (click)="handleClick($event)">
    <span class="button-content">
        <ng-container *ngIf="label; else contentSlot">{{ label }}</ng-container>
        <ng-template #contentSlot>
            <ng-content select="[button-icon]"></ng-content>
            <ng-content select="[button-text]"></ng-content>
            <ng-content></ng-content>
        </ng-template>
    </span>
</a>

<!-- Botón con href (enlace externo) -->
<a *ngIf="href" [href]="href" [target]="target" [class]="buttonClasses" [attr.disabled]="disabled ? true : null"
    (click)="handleClick($event)" rel="noopener noreferrer">
    <span class="button-content">
        <ng-container *ngIf="label; else contentSlotHref">{{ label }}</ng-container>
        <ng-template #contentSlotHref>
            <ng-content select="[button-icon]"></ng-content>
            <ng-content select="[button-text]"></ng-content>
            <ng-content></ng-content>
        </ng-template>
    </span>
</a>

<!-- Botón normal (sin navegación) o solo con scrollTo -->
<button *ngIf="route === undefined && !routerLink && !href" [type]="'button'" [class]="buttonClasses"
    [disabled]="disabled" (click)="handleClick($event)">
    <span class="button-content">
        <ng-container *ngIf="label; else contentSlot2">{{ label }}</ng-container>
        <ng-template #contentSlot2>
            <ng-content select="[button-icon]"></ng-content>
            <ng-content select="[button-text]"></ng-content>
            <ng-content></ng-content>
        </ng-template>
    </span>
</button>